import { render } from "./consumerAccount.vue?vue&type=template&id=a8f0e7fe"
import script from "./consumerAccount.vue?vue&type=script&lang=js"
export * from "./consumerAccount.vue?vue&type=script&lang=js"

import exportComponent from "/data/spug/spug_api/repos/34_1470_20220520214630/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__